<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gsZtUI/tc-custom/9781439675908.jpg?1737640499771" alt="This image is the cover for the book The Ghostly Tales of San Diego, Spooky America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Ghostly Tales of San Diego, Spooky America
      </h1>
      <p class="bookDescription body article font2">
        <p>Ghost stories from San Diego, California have never been so creepy, fun, and full of mystery! </p><br/><p>The haunted history of San Diego comes to life—even when the main players are dead. Wander into the shops of Old Town, just keep your eye out for shoppers who might have died long ago. Or check into the Cosmopolitan Hotel for a glimpse of guests who checked in but never checked out. Dive into this spooky chapter book for suspenseful tales of bumps in the night, paranormal investigations, and the unexplained; just be sure to keep the light on.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Selena Fragassi
      </h2>
      
      <p class="authorDescription body article">Selena Fragassi is a Chicago-based writer who grew up in a real haunted house and has loved all things paranormal since she had her first experience with a ghost as a teenager. In addition to writing for Spooky America, Selena is a music journalist and has written for such publications as the Chicago Sun-Times, Chicago Tribune, A.V. Club, Blurt, Paste, Popmatters, Under The Radar and Nylon, among others. She is also working on an upcoming novel about her grandfathers' experiences during World War II.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71334412